/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { SvgIconProps } from '@mui/material';
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from '../styles';

interface Props extends SvgIconProps {
  checked: boolean | undefined;
}

function Checkmark({ checked, ...props }: Readonly<Props>) {
  return checked ? <CheckboxCheckedIcon {...props} /> : <CheckboxUncheckedIcon {...props} />;
}

export default Checkmark;
